import { TableString } from 'src/app/models/table-string.model';
import { UtilsService } from 'src/app/services/utils.service';

export class ActivityData {
	public ActivityObjectClientId: string;

	public StartDateId: number;
	public StartDate: Date | number | string;

	public EndDateId: number;
	public EndDate: Date | number | string;

	public Quantity: number;
	public Probability: number;
	
	public ActivityItemListId: number;
	public ActivityListName: TableString;

	public Comment: string;

	public DeterminationDateId: number;
	public DeterminationDate: Date | number | string;
	
	public ApplyToForecast: boolean;

	public ForecastElementId: number;
	public ForecastElementName: TableString;
	
	public ResponsibleUserId: number;
	public UserName: TableString;

	public Probability2: number;
	public ActivityObjectId:number;
	// public ActivityGroup1: string;
	// public ActivityGroup2: string;
	// public ActivityGroup3: string;
	// public ActivityGroup4: string;
	// public ActivityGroup5: string;
	// public ActivityGroup6: string;
	// public ActivityGroup7: string;
	// public ActivityGroup8: string;
	// public ActivityGroup9: string;
	// public ActivityGroup10: string;
	// public ActivityGroup11: string;
	// public ActivityGroup12: string;
	// public ActivityGroup13: string;
	// public ActivityGroup14: string;

	constructor() {
	}

	public initialize() {
		this.StartDate = UtilsService.convertDateIdToDate(this.StartDateId);
		this.EndDate = UtilsService.convertDateIdToDate(this.EndDateId);
		this.DeterminationDate = UtilsService.convertDateIdToDate(this.DeterminationDateId);
	}

	public prepareForSave() {
		this.StartDateId = UtilsService.convertDateToDateId(this.StartDate);
		this.EndDateId = UtilsService.convertDateToDateId(this.EndDate);
		this.DeterminationDateId = UtilsService.convertDateToDateId(this.DeterminationDate);
	}
}

export class ActivityDataNew {

	public ActivityObjectClientId: string; 
	public StartDateId: number; 
	public EndDateId: number;  
	public Quantity: number;
	public Probability: number; 
	public ActivityItemListId: number;  
	public Comment: string; 
	public DeterminationDateId: number;  
	public ApplyToForecast: boolean; 
	public ForecastElementId: number;  
	public ResponsibleUserId: number;  
	public Probability2: number; 
	public GroupData: GroupData[];
	public ActivityObjectId : number; 
	constructor() {
	}
}


export class GroupData {
	public KeyPair: string;
	public ValuePair: string; 
}
